<div class="main-container">
  <div class="afiliaciones-content row">
    <h1>Consulta Mis Afiliaciones</h1>
    <span style="font-size: medium; color: var(--mid-gray-color)">
      Filtre la consulta deseada
    </span>
    <br /><br /><br />
    <form [formGroup]="frmAfiliaciones">
      <!-- DIV GENERAL -->
      <div class="form-container row">
        <!-- Primer DIV -->
        <div class="col-8">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>No. de Identificación</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="identificacion"
                  maxlength="20"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                />
                <mat-error *ngIf="hasError(getControl['identificacion'])">
                  {{
                    printError(getControl["identificacion"], {
                      noSpaces: "No se permite espacios"
                    })
                  }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Línea</mat-label>
                <mat-select formControlName="linea">
                  <mat-option *ngFor="let l of lineas" [value]="l">{{
                    l
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Plan</mat-label>
                <mat-select formControlName="plan">
                  <mat-option *ngFor="let p of planes" [value]="p">{{
                    p
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo Solicitud</mat-label>
                <mat-select formControlName="tipoSolicitud">
                  <mat-option *ngFor="let t of tiposSolicitud" [value]="t">{{
                    t
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Canal</mat-label>
                <mat-select formControlName="canal">
                  <mat-option *ngFor="let c of canales" [value]="c">{{
                    c
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field
                appearance="outline"
                style="width: 100%"
                floatLabel="always"
              >
                <mat-label>Fecha Radicación</mat-label>
                <input
                  id="txtFechaRadicacion"
                  matInput
                  [matDatepicker]="pickerRadicacion"
                  formControlName="fechaRadicacion"
                  [min]="minFechaRadicacion"
                  [max]="maxFechaRadicacion"
                  (dateChange)="onChangeFechaRadicacion($event)"
                  [placeholder]="'YYYY/MM/DD'"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerRadicacion"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickerRadicacion touchUi></mat-datepicker>

                <!-- Mensajes de error -->

                <mat-hint
                  style="color: red"
                  *ngIf="
                    getControl['fechaRadicacion'].hasError('matDatepickerParse')
                  "
                >
                  Fecha inválida. Usa el formato YYYY/MM/DD.
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- SEGUNDO DIV-->
        <div class="col-4">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-7">
              <button
                type="submit"
                class="btn btn-primary btn-icon"
                (click)="consultar()"
                appTrackClick
                [trackData]="trackDataCarnet"
              >
                <mat-icon>search</mat-icon><span>CONSULTAR</span>
              </button>
            </div>
            <div class="col-12 col-md-6 col-lg-5">
              <button class="btn btn-primary btn-icon" (click)="clear()">
                <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Tabla de resultados -->
    <div *ngIf="haveResponde">
      <div
        class="mat-elevation-z8 col-12"
        [ngClass]="{ 'hide-table': !haveDataToShow }"
        style="display: flex; flex-direction: column; min-width: 300px"
      >
        <mat-table mat-table [dataSource]="dsAfiliaciones" matSort>
          <ng-container
            [matColumnDef]="dt"
            *ngFor="let dt of attrData; let i = index"
          >
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ namesColumns[i] }}
            </mat-header-cell>
            <mat-cell class="break-word" *matCellDef="let element">
              {{ element[dt] }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="attrData"></mat-header-row>
          <mat-row *matRowDef="let row; columns: attrData"></mat-row>
        </mat-table>
      </div>

      <div style="text-align: center" *ngIf="!haveDataToShow">
        <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
      </div>
    </div>

    <div *ngIf="!haveResponde" class="message-container">
      <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
    </div>
  </div>
</div>